import { render } from "./PageFormDokumenTambahan.vue?vue&type=template&id=11184f62"
import script from "./PageFormDokumenTambahan.vue?vue&type=script&lang=js"
export * from "./PageFormDokumenTambahan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__